import { Stack, Typography } from "@mui/material";
import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { CeCheckbox } from "../generic/components/form-fields/ce-checkbox";
import type { CreateContentRequest } from "../multiformat/store/types";
import { useFormContext } from "react-hook-form";

export const ImageStyleSelector: FC<{ config: Record<string, number> }> = ({ config }) => {
  const { t } = useTranslation();
  const photoCount = config["photo"] ?? 0;
  const illustrationCount = config["illustration"] ?? 0;
  const iconCount = config["icon"] ?? 0;

  const { watch } = useFormContext<CreateContentRequest>();
  const format = watch("format");

  return (
    <Stack direction="row" gap={0} sx={{ color: "text.primary" }}>
      {format !== "Video" && (
        <>
          <Typography sx={{ py: 1, pr: 1 }} variant="body1" color="text.primary">
            Imagery style:
          </Typography>
          <CeCheckbox<CreateContentRequest>
            label={t("Stock imagery ({{count}})", { count: photoCount })}
            name="image_style.photo"
            disabled={photoCount === 0}
          />
          <CeCheckbox<CreateContentRequest>
            label={t("Illustrations ({{count}})", { count: illustrationCount })}
            name="image_style.illustration"
            disabled={illustrationCount === 0}
          />
          <CeCheckbox<CreateContentRequest>
            label={t("Icons ({{count}})", { count: iconCount })}
            name="image_style.icon"
            disabled={iconCount === 0}
          />
        </>
      )}
    </Stack>
  );
};
